<script setup>
import { computed } from 'vue';
import Draggable from 'vuedraggable';
import {
  isCurrentMonth,
  isToday,
} from 'dashboard/components/ui/DatePicker/helpers/DatePickerHelper';
import CalendarEventPill from './CalendarEventPill.vue';

const props = defineProps({
  day: {
    type: Date,
    required: true,
  },
  referenceDate: {
    type: Date,
    required: true,
  },
  events: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['selectEvent', 'change']);

const isInCurrentMonth = computed(() =>
  isCurrentMonth(props.day, props.referenceDate)
);
const isCurrentDay = computed(() => isToday(new Date(), props.day));
</script>

<template>
  <div
    class="flex flex-col h-full min-h-[96px] gap-1 p-1.5 border-b border-r border-n-weak"
    :class="{ 'bg-n-solid-1': !isInCurrentMonth }"
  >
    <span
      class="flex items-center justify-center text-xs font-medium rounded-full size-6"
      :class="[
        isCurrentDay ? 'bg-n-brand text-white' : 'text-n-slate-11',
        !isInCurrentMonth && 'opacity-50',
      ]"
    >
      {{ day.getDate() }}
    </span>
    <Draggable
      :list="events"
      group="calendar-events"
      item-key="id"
      animation="150"
      ghost-class="opacity-50"
      filter=".calendar-event--readonly"
      :prevent-on-filter="false"
      :disabled="disabled"
      class="flex flex-col gap-1 overflow-y-auto"
      @change="emit('change', $event)"
    >
      <template #item="{ element }">
        <CalendarEventPill
          :event="element"
          :class="{
            'calendar-event--readonly':
              element.sourceType !== 'contact_attribute',
          }"
          @click="emit('selectEvent', $event)"
        />
      </template>
    </Draggable>
  </div>
</template>
